<template>
  <div slot="content">
    <!-- Loader -->
    <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="getIsLoading">
      <gd-loader :label="$t('frontend_loading')"/>
    </div>

    <!-- target for other loders -->
    <portal-target name="loaderTarget"></portal-target>

    <!-- target for modals -->
    <portal-target name="modalsTarget"></portal-target>

    <div class="w-full h-full flex">
      <!-- <VuePerfectScrollbar class="w-full h-full" :settings="scrollbarSettings"> -->
      <div class="w-full h-full">
        <transition :name="routerTransition">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </div>
      <!-- </VuePerfectScrollbar> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },

  computed: {
    ...mapGetters('loader', ['getIsLoading']),

    menuItems() {
      return [];
    },
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
  },
};
</script>

